import type { AttachmentType } from '@liks/backend-svc-api/esm/models/index';

export function resolveUploadAttachmentType(file: File): AttachmentType {
  if (file.type.startsWith('audio/')) {
    return 'AUDIO';
  }
  return 'DOCUMENT';
}
